// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { FeeType } from './fee-type';
import { Invoice } from './invoice';
import { OrderLineDetail } from './order-line-detail';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class InvoiceLine extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  static SALES_TAX_Rate = 0.06;

get lineTotal() {
    return this.price * this.quantity;
  }

  get lineTax() {
    return this.isTaxable ? this.lineTotal * InvoiceLine.SALES_TAX_Rate : 0;
  }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  created!: Date;
  createdBy?: string;
  deleted?: Date;
  deletedBy?: string;
  description?: string;
  feeTypeId?: number;
  invoiceId!: number;
  isTaxable!: boolean;
  lineNumber!: number;
  orderLineDetailId?: number;
  partNumber?: string;
  price!: number;
  quantity!: number;
  feeType!: FeeType;
  invoice!: Invoice;
  orderLineDetail!: OrderLineDetail;
}

